import { InSeason2027 } from '#src/atoms/icons/SeasonalityIcon/InSeason.tsx';
import { SorareLogo } from '#src/atoms/icons/SorareLogo/index.tsx';
import { Horizontal } from '#src/atoms/layout/flex/index.tsx';
import type { Unit } from '#src/lib/style.ts';
import type { Color, HexColorOnly } from '#src/style/types.ts';

type Size = 'small' | 'regular' | 'medium' | 'large';

const SIZE_CONFIG = {
  small: { gap: 0.5, iconSize: 1.5 },
  regular: { gap: 1, iconSize: 2 },
  medium: { gap: 1, iconSize: 3 },
  large: { gap: 1, iconSize: 6 },
} as const;

type Props = {
  size?: Size;
  color?: Color | HexColorOnly;
  iconSize?: Unit;
};

export const NewSeasonLogo = ({
  size = 'medium',
  color = 'var(--c-white)',
  iconSize: iconSizeOverride,
}: Props) => {
  const { gap, iconSize } = SIZE_CONFIG[size];

  return (
    <Horizontal gap={gap}>
      <SorareLogo size={size} color={color} />
      <InSeason2027 size={iconSizeOverride ?? iconSize} color={color} />
    </Horizontal>
  );
};
